import { apiWithAuth } from "@/lib/axios";
import type { Skill } from "./types";

type Category = {
  id: string;
  name: string;
  sortOrder?: number;
};

export const listCategoriesSkill: Skill = {
  id: "listCategories",
  description:
    "Lista las categorías del menú de un restaurante (id + nombre). Úsala SIEMPRE que necesites el ID de una categoría para alguna otra acción (createProduct con categoría, moveProductToCategory, etc.) — NUNCA pidas el ID al usuario, busca tú la categoría por nombre dentro del resultado.",
  schema: {
    type: "object",
    properties: {
      restaurantId: { type: "string", description: "ID del restaurante" },
    },
    required: ["restaurantId"],
  },
  async run(args, ctx) {
    if (!ctx.accessToken) {
      return { ok: false, error: "Sesión no disponible." };
    }
    const restaurantId = String(args.restaurantId ?? "");
    if (!restaurantId) {
      return { ok: false, error: "Falta restaurantId." };
    }

    if (ctx.follow.enabled) {
      await ctx.follow.step("Listando categorías…", { durationMs: 400 });
    }

    try {
      const { data } = await apiWithAuth.get(
        `/restaurants/${restaurantId}/product-categories`,
        ctx.accessToken,
      );
      const items: Category[] = (data?.items ?? data?.data ?? data ?? []).map(
        (c: Category) => ({
          id: c.id,
          name: c.name,
          sortOrder: c.sortOrder,
        }),
      );

      if (ctx.follow.enabled) {
        await ctx.follow.step(`✓ ${items.length} categoría(s)`, {
          durationMs: 400,
          spinner: false,
        });
        ctx.follow.clear();
      }

      return {
        ok: true,
        result: { count: items.length, categories: items },
        humanSummary: `${items.length} categoría(s) encontrada(s).`,
      };
    } catch (err) {
      return {
        ok: false,
        error: (err as Error)?.message ?? "Error obteniendo categorías.",
      };
    }
  },
};
